import React, { useState } from 'react';
import './Login.css';
import api from '../utils/api';

const Login = ({ onLogin }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    payout_doge_address: '',
    agreedToTos: false
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        // Login
        const response = await api.post('/api/auth/login', {
          username: formData.username,
          password: formData.password
        });
        onLogin(response.data.token, response.data.user);
      } else {
        // Register
        if (!formData.payout_doge_address) {
          setError('Payout address is required for registration');
          setLoading(false);
          return;
        }
        
        // Validate password confirmation
        if (formData.password !== formData.confirmPassword) {
          setError('Passwords do not match');
          setLoading(false);
          return;
        }
        
        if (formData.password.length < 6) {
          setError('Password must be at least 6 characters');
          setLoading(false);
          return;
        }

        // Validate Terms of Service agreement
        if (!formData.agreedToTos) {
          setError('You must agree to the Terms of Service to register');
          setLoading(false);
          return;
        }
        
        const response = await api.post('/api/auth/register', {
          username: formData.username,
          password: formData.password,
          payout_doge_address: formData.payout_doge_address
        });
        onLogin(response.data.token, response.data.user);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-window win98-bevel">
        <div className="login-header">
          <h1 className="login-title">🐕 DogeChat 🐕</h1>
          <p className="login-subtitle">Much Wow! Very Chat!</p>
        </div>
        
        <div className="login-tabs">
          <button
            className={`tab-button ${isLogin ? 'active' : ''}`}
            onClick={() => setIsLogin(true)}
          >
            Login
          </button>
          <button
            className={`tab-button ${!isLogin ? 'active' : ''}`}
            onClick={() => setIsLogin(false)}
          >
            Register
          </button>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label>Username:</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              className="win98-bevel-inset"
              maxLength={50}
            />
          </div>

          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              className="win98-bevel-inset"
              minLength={6}
            />
          </div>

          {!isLogin && (
            <>
              <div className="form-group">
                <label>Confirm Password:</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  className="win98-bevel-inset"
                  minLength={6}
                />
                {formData.confirmPassword && formData.password && formData.password !== formData.confirmPassword && (
                  <span className="password-mismatch">⚠️ Passwords do not match</span>
                )}
                {formData.confirmPassword && formData.password && formData.password === formData.confirmPassword && (
                  <span className="password-match">✓ Passwords match</span>
                )}
              </div>
              <div className="form-group">
                <label>Payout DOGE Address:</label>
                <input
                  type="text"
                  name="payout_doge_address"
                  value={formData.payout_doge_address}
                  onChange={handleChange}
                  required
                  className="win98-bevel-inset"
                  placeholder="D... (for receiving contest winnings)"
                />
              </div>
              <div className="form-group tos-checkbox-group">
                <label className="tos-checkbox-label">
                  <input
                    type="checkbox"
                    name="agreedToTos"
                    checked={formData.agreedToTos}
                    onChange={(e) => setFormData({ ...formData, agreedToTos: e.target.checked })}
                    className="tos-checkbox"
                    required
                  />
                  <span>
                    I have read and agree to the{' '}
                    <a href="/tos" target="_blank" rel="noopener noreferrer" className="tos-link">
                      Terms of Service & Community Rules
                    </a>
                  </span>
                </label>
              </div>
            </>
          )}

          <button
            type="submit"
            disabled={loading}
            className="win98-button submit-button"
          >
            {loading ? 'Loading...' : (isLogin ? 'Login' : 'Register')}
          </button>
        </form>

        <div className="login-footer">
          <p>💰 Send 1 DOGE to chat! 🎉</p>
          <p>🏆 Daily contests! Much win!</p>
        </div>
      </div>
    </div>
  );
};

export default Login;

